module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k6e0b"))).then(() => parcelRequire('fThBo'));